export const logger = {
    // This is a dummy logger, should be replaced with a proper logger in future.
    info: (_errorMessage: string, _contextData?: Record<string, unknown>) => {},
    warn: (_errorMessage: string, _contextData?: Record<string, unknown>) => {},
    error: (_errorMessage: string, _contextData?: Record<string, unknown>) => {},
  };